import React from 'react';
import ProductCardList from 'components/NewHome/ProductCardList';
import MobileProductModuleList from 'components/NewHome/Mobile/MobileProductModuleList';
import { relatoriosProductsList } from 'helper/Home/productCardList';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function RelatoriosHome() {
  if (useIsMobile()) {
    return <MobileProductModuleList title="RELATÓRIOS" products={relatoriosProductsList} />;
  }

  return (
    <div className="dark-outlet-background">
      <h1 className="mb-5">RELATÓRIOS</h1>
      <ProductCardList products={relatoriosProductsList} />
    </div>
  );
}
